import styled from 'styled-components';
import {
  Steps,
} from 'antd';
import { COLOR_CV_2, COLOR_CV_6 } from 'constants/colors';

export const StyledAntdSteps = styled(Steps)`
  & .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
    background-color: ${COLOR_CV_6};
    border-color: ${COLOR_CV_6};
  }

  & .ant-steps-item-finish {
    & .ant-steps-item-icon {
      border-color: ${COLOR_CV_6};

      & > .ant-steps-icon {
        color: ${COLOR_CV_6};
      }
    }

    & > .ant-steps-item-container > .ant-steps-item-tail::after {
      background-color: ${COLOR_CV_6};
    }
  }

  & .ant-steps-item {
    & > .ant-steps-item-container[role='button']:hover {
      .ant-steps-item {
        &-title {
          color: ${COLOR_CV_2};
        }
      }
    }
    
    &:not(.ant-steps-item-active):not(.ant-steps-item-process) {
      & > .ant-steps-item-container[role='button']:hover {
          .ant-steps-item {
            &-icon, &-title {
              border-color: ${COLOR_CV_2};
              color: ${COLOR_CV_2};
    
              .ant-steps-icon {
                color: ${COLOR_CV_2};
              }
            }
          }
        }
      }
    }
  }
`;
